// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseElement } from '../../../../../com/MetaPattern/MDA/MD/Base/BaseElement';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 实体元数据基类 实体类
 * 所有实体元数据基类
 */
export abstract class BEBaseElement extends BaseElement {
  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
  }
}
